import { KeyValue } from "./base-model";

export class TodoItemNode {
  children: TodoItemNode[];
  item: string;
  itemCollectionEntryName?: string;
  ContainerId: string;
  CollectionId?: string;
  IsSelected?: boolean;
  Attributes?: TreeAttributeType[];
  CollectionAttributes? : any[];
  CollectionEntryId?: string;
  TerraformResourceName?: string;
  collection?: any;
  CreatedDate?: any;
  CreatedBy?: any;
  UpdatedDate?: any;
  UpdatedBy?: any;
  ResourceStateMessage?: any;
  ResourceState?: any;
  IsShowAudit?: boolean;
  deployedServices? : any[];
  stateDetail? : any;
  isShowAttribute?: boolean = true;
  CollectionEntryName?: string;
  IsCheckBoxDisabled?: boolean;
}

export class PoolItemNode {
  children?: PoolItemNode[];
  value: PoolDetail;
  
}

export class PoolDetail{
  cidr_block: string;
  cloud: string;
  vpc_id: string;
  vpc: string;
  subnet: string;
  subnet_id: string;
}

export class PoolItemFlatNode {
  item: PoolDetail;
  level: number;
  expandable: boolean;
  IsSelected: boolean;
  isUserExpanded: boolean;
  isCSPExpanded: boolean;
  Color: string;
}

/** Flat to-do item node with expandable and level information */
export class TodoItemFlatNode {
  item: string;
  ItemName: string;
  level: number;
  expandable: boolean;
  ContainerId: string;
  CollectionId?: string;
  UserAttributes: any;
  CSPAttributes: any;
  DeployedServicesHtml: any;
  DeployedServices: any[];
  StateDetail: any;
  DevicePolicies: any[];
  DevicePoliciesHtml: any;
  IsSelected: boolean;
  isUserExpanded: boolean;
  isCSPExpanded: boolean;
  isAuditExpanded: boolean;
  isDetailsExpanded: boolean;
  isDeployedServiceExpanded: boolean;
  isStateDetailExpanded:boolean;
  Color: string;
  CollectionAttributes: any[];
  CollectionEntryId?: string;
  TerraformResourceName?: string;
  CreatedDate?: any;
  CreatedBy?: any;
  UpdatedDate?: any;
  UpdatedBy?: any;
  ResourceStateMessage?: any;
  ResourceState?: any;
  IsShowAudit: boolean;
  isShowAttribute?: boolean;
  IsCheckBoxDisabled?: boolean;
  colorStatus?: any;
  resourceState?: any;
  stateDetailStatus?: any;
}

export class TreeAttributeType {
  Id: string;
  Value: string;
  Name: string;
  DisplayName: string;
  AttributeType?: string;
  IsComplex?: boolean
  IsList?: boolean;
  IsFile?: boolean;
  Color: string;
  DataUrl: string;
  Attribute: any;
}
